import script from "./DrawImage.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawImage.vue?vue&type=script&setup=true&lang=js"

import "./DrawImage.vue?vue&type=style&index=0&id=3298d9b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3298d9b7"]])

export default __exports__